import { ssoCallback } from './sso-callback';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { plugin, defaultConfig } from '@formkit/vue'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { db, dbPopulate, logger } from '@lib/pp-shop-lib/helpers';
import { useAlertStore, useAuthStore, useConfigStore } from '@lib/pp-shop-lib/stores';
import { createI18n } from 'vue-i18n'
import messages from '@intlify/unplugin-vue-i18n/messages'
import { datetimeFormats, numberFormats } from '@/locales/js'
import { useStorage } from '@vueuse/core'
import * as Sentry from "@sentry/vue";

import 'vue-loading-overlay/dist/css/index.css';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { fas } from '@fortawesome/free-solid-svg-icons'
/* add icons to the library */
library.add(fas)
import formkitConfig from '@/config/formkit.config.js'

import App from './App.vue';
import { router } from './router';
import { trySsoHandover } from './utils/sso';

function validateBootstrapConfig(config) {
    const warnings = []

    if (!config || typeof config != 'object') {
        warnings.push('pp-client-config fehlt oder ist kein Objekt')
        return warnings
    }

    if (!config.apiUrl || typeof config.apiUrl != 'string') {
        warnings.push('apiUrl fehlt oder ist kein String')
    }

    if (!config.hubUrl || typeof config.hubUrl != 'string') {
        warnings.push('hubUrl fehlt oder ist kein String')
    }

    if (typeof config.globalNav != 'boolean') {
        warnings.push('globalNav sollte Boolean sein')
    }

    return warnings
}

if (!window.ppShop) window.ppShop = {}
window.ppShop.router = router

const app = createApp(App).use(
    plugin,
    defaultConfig(formkitConfig)
)
// Sentry.init({
//     app,
//     dsn: "https://f8399a6c215a4fc8420ce1db2a8eec24@o4509230799060992.ingest.de.sentry.io/4509230805942352",
//     // Setting this option to true will send default PII data to Sentry.
//     // For example, automatic IP address collection on events
//     sendDefaultPii: true
// });

  
app.component('font-awesome-icon', FontAwesomeIcon)

const pinia = createPinia()
window.ppShop.pinia = pinia

pinia.use(piniaPluginPersistedstate)

app.use(pinia);

const configStore = useConfigStore(pinia)
const authStore = useAuthStore(pinia)
const bootstrapConfig = window.__PP_CLIENT_CONFIG__ || window.ppClientConfig || {}
const configWarnings = validateBootstrapConfig(bootstrapConfig)
configStore.setConfig(bootstrapConfig)

try {
    delete window.__PP_CLIENT_CONFIG__
    delete window.ppClientConfig
} catch (e) {
    window.__PP_CLIENT_CONFIG__ = undefined
    window.ppClientConfig = undefined
}

logger.setClientIdGetter(() => authStore.getClientId())
logger.setProviders(configStore.logger)

if (configWarnings.length) {
    configWarnings.forEach((w) => {
        console.warn(`[config] ${w}`)
        logger.warn(`[config] ${w}`)
    })
}

const defaultLocale = useStorage('locale', 'de-DE')
const i18n = createI18n({
      locale: defaultLocale.value,
      legacy: false,
      globalInjection: true,
      messages,
      datetimeFormats,
      numberFormats
    })  
app.use(i18n)

db.on('ready', dbPopulate)

// Wenn kein Einhängepunkt vorhanden, einen erstellen
if (!document.querySelector('#pp-shop')) {
    const appElem = document.createElement("div")
    appElem.setAttribute("id", "pp-shop")
    appElem.setAttribute("style", "height:0")
    document.body.appendChild(appElem)
}
async function startApp() {
    const ssoResult = await trySsoHandover(configStore, authStore, ssoCallback)
    if (ssoResult === 'redirecting') return

    // Installed after the SSO handover so the initial navigation and guards see the final login state.
    app.use(router)
    await router.isReady()
    if (ssoResult === 'failed') {
        useAlertStore(pinia).error('auth.ssoFailed')
    }
    app.mount('#pp-shop')
}

startApp().catch((error) => {
    logger.error('[bootstrap] App startup failed', error)
})
